import { Button, message, Row, Typography } from 'antd';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import HeaderComponent from '../../../components/BlogComponents/HeaderComponent';
import Footer from '../../../components/HomePageFooter/HomePageFooter';
import SpinnerComponent from '../../../components/SpinnerComponent/SpinnerComponent';
import { REQUEST_LOADING_STATES } from '../../../helpers/constant';
import { getBlogDetails } from '../../../redux/blogs/blogSlice';
import { AppDispatch, StoreState } from '../../../redux/store';
import "./BlogDetailsComponent.less";

const BlogDetailsComponent = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { selectedBlog, loading, error } = useSelector((state: StoreState) => state.blog);

  const classesByIndex: any = useMemo(() => {
    return {
      0: "left half",
      2: "container left"
    }
  }, []);

  useEffect(() => {
    if (!id) return;

    dispatch(getBlogDetails({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error])

  return (
    <div className="blog-details-wrapper">
      <div className='blog-details-layout'>
        <HeaderComponent />
        <Row className='detail-row'>
          <Typography.Text className='home-title'><span>Twizz</span>Blog</Typography.Text>


          {
            loading === REQUEST_LOADING_STATES.PENDING && <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <SpinnerComponent />
            </div>
          }

          {
            loading === REQUEST_LOADING_STATES.SUCCEEDED && selectedBlog && <>
              {
                selectedBlog?.blogDescription?.map((bDescription) => (
                  <Row key={bDescription?.index} className={`section-holder ${classesByIndex[bDescription?.index]}`}>
                    <Typography.Text
                      className='section-title'
                      style={{ textTransform: bDescription?.index === 0 ? "uppercase" : "none" }}
                    >
                      {bDescription.index === 0 ? selectedBlog?.title : bDescription?.title}
                    </Typography.Text>

                    <Typography.Text className='section-description'>
                      {bDescription.description || ""}
                    </Typography.Text>


                    {
                      bDescription.buttonUrl && bDescription.buttonText && (
                        <Link to={bDescription?.buttonUrl}>
                          <Button type="default" shape="round" className={"section-button"}>
                            {bDescription.buttonText}
                          </Button>
                        </Link>
                      )
                    }

                  </Row>
                ))
              }
            </>
          }

        </Row>
      </div>
      <Footer hideElement={["blog"]} hideFooter={true} />
    </div>
  )
}

export default BlogDetailsComponent
